<page-headline
    [linkTitle]="linkTitle"
    [moduleLink]="moduleLink"
    [module]="'settings'"
    [moduleIcon]="'fa-user-cog'"
    [pageTitle]="'Settings'"
>
</page-headline>

<div class="row-layout-track-left-align">
    <div class="settngs-layout-box-left">
        <div id="menuSelector">
            <div *ngFor="let section of settings">
                <div class="menuSectionItem" (click)="sectionExpand(section)">
                    {{ section.name }}
                    <span class="itemDropDown">
                        <i
                            class="far"
                            [ngClass]="{
                                'fa-angle-down': !section.expanded,
                                'fa-angle-up': section.expanded
                            }"
                        ></i>
                    </span>
                </div>
                <div *ngFor="let item of section.modules">
                    <!-- Main level menu items -->
                    <div
                        *ngIf="section.expanded"
                        class="menuSelectorItem"
                        (click)="selectItem(item)"
                        [ngClass]="{
                            menuSelectorItemCurrent: item.key == selectedItem
                        }"
                    >
                        {{ item.name }}
                        <span class="itemDropDown" *ngIf="item.subModules">
                            <i
                                class="far"
                                (click)="subSectionExpand(item)"
                                [ngClass]="{
                                    'fa-angle-down': !item.expanded,
                                    'fa-angle-up': item.expanded
                                }"
                            ></i>
                        </span>
                    </div>

                    <!-- Sub menu items -->
                    <div *ngIf="item.expanded && section.expanded">
                        <ng-container *ngFor="let subItem of item.subModules">
                            <div
                                class="menuSelectorItem menuSelectorSubItem"
                                *ngIf="subItem.key !== 'change-password'"
                                (click)="selectItem(item, subItem)"
                                [ngClass]="{
                                    menuSelectorItemCurrent: subItem.key == selectedItem
                                }"
                            >
                                {{ subItem.name }}
                            </div>
                        </ng-container>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Settings Body -->
    <div class="settngs-layout-box-right">
        <!-- Profile - Account Details -->
        <app-employee-record-view *ngIf="isSelected('user-profile')"></app-employee-record-view>
        <app-profile-account-details
            *ngIf="isSelected('account-details')"
        ></app-profile-account-details>
        <app-change-password *ngIf="isSelected('change-password')"></app-change-password>

        <!-- Profile - Notifications -->
        <app-profile-notifications *ngIf="isSelected('notifications')"></app-profile-notifications>

        <!-- Profile - User Level Subscriptions -->
        <app-user-subscriptions *ngIf="isSelected('user-subscriptions')"></app-user-subscriptions>

        <!-- Profile - Scheduled Reports -->
        <app-scheduled-reports *ngIf="isSelected('scheduled-reports')"></app-scheduled-reports>

        <!-- Company - Integration -->
        <app-client-product-mapping
            *ngIf="isSelected('client-product-mapping') && (isSuperUser || isClientPowerUser)"
        ></app-client-product-mapping>
        <app-loan-characteristics-mapping
            *ngIf="isSelected('loan-characteristics-mapping') && (isSuperUser || isClientPowerUser)"
        >
        </app-loan-characteristics-mapping>
        <app-general-ledger-mapping
            *ngIf="isSelected('general-ledger-mapping') && (isSuperUser || isClientPowerUser)"
        >
        </app-general-ledger-mapping>
        <app-integration *ngIf="isSelected('integration-setup')"></app-integration>
        <file-upload-integration
            *ngIf="isSelected('file-upload') && isSuperUser"
        ></file-upload-integration>
        <delete-loan
            *ngIf="isSelected('delete-loan') && (isClientPowerUser || isSuperUser)"
        ></delete-loan>
        <invoiced-loans
            *ngIf="isSelected('invoiced-loans') && (isClientPowerUser || isSuperUser)"
        ></invoiced-loans>
        <holiday-hours *ngIf="isSelected('holiday-hours')"></holiday-hours>

        <!-- Company - Performance -->
        <app-kpi-config *ngIf="isSelected('performance-kpi-config')"></app-kpi-config>
        <app-kpi-scorecard *ngIf="isSelected('kpi-profiles')"></app-kpi-scorecard>
        <app-branch-projections-config
            *ngIf="isSelected('branch-projections-config')"
        ></app-branch-projections-config>

        <!-- Company - Domains -->
        <app-domain-management *ngIf="isSelected('domain-management')"></app-domain-management>

        <!-- Company - Roles & Users - User Management-->
        <app-user-management *ngIf="isSelected('user-management')"></app-user-management>
        <app-employee
            *ngIf="isSelected('employees')"
            [events]="eventsSubject.asObservable()"
        ></app-employee>

        <!-- Company - Roles & Users - Role Management -->
        <app-role-management *ngIf="isSelected('role-management')"></app-role-management>

        <milestones-events *ngIf="isSelected('milestones-events')"></milestones-events>

        <app-lba-clients *ngIf="isSelected('lba-clients') && isSuperUser"></app-lba-clients>

        <hierarchy-config *ngIf="isSelected('hierarchy-levels') && isSuperUser"></hierarchy-config>

        <app-company-notifications
            *ngIf="isSelected('notification-types') && (isSuperUser || isClientPowerUser)"
        >
        </app-company-notifications>

        <app-e-close-roi-settings
            *ngIf="isSelected('eclose-roi-settings') && (isSuperUser || isClientPowerUser)"
        ></app-e-close-roi-settings>

        <app-subscriptions
            *ngIf="isSelected('subscriptions') && (isSuperUser || isClientPowerUser)"
        >
        </app-subscriptions>

        <!-- SimpleNexus Admin - Client Module Access -->
        <app-lba-subscriptions
            *ngIf="isSelected('lba-subscriptions') && isSuperUser"
        ></app-lba-subscriptions>

        <!-- SimpleNexus Admin - Users -->
        <app-lba-users *ngIf="isSelected('super-users') && isSuperUser"></app-lba-users>

        <!-- SimpleNexus Admin - Client Health -->
        <app-client-health *ngIf="isSelected('company-health') && isSuperUser"></app-client-health>

        <!-- SimpleNexus Admin - Login Activity -->
        <app-lba-login-activity
            *ngIf="isSelected('login-activity')"
            view="client"
        ></app-lba-login-activity>
        <!-- SimpleNexus Admin - Login Activity -->
        <app-lba-login-activity
            *ngIf="isSelected('lba-login-activity') && isSuperUser"
            view="admin"
        ></app-lba-login-activity>
        <!-- DEFAULT placeholder for setting items without pages -->
        <mat-card class="large-card" *ngIf="moduleHasNotBeenCreated(selectedItem)">
            <div class="settingsBody">
                <span class="settingsTitle">Placeholder Setting</span>
            </div>
        </mat-card>
    </div>
</div>
